export enum CurrentOfferStatus {
    active = 'active',
    finished = 'finished',
}
